import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=70ae8b48&scoped=true&"
import script from "./MemberList.vue?vue&type=script&lang=ts&"
export * from "./MemberList.vue?vue&type=script&lang=ts&"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=70ae8b48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae8b48",
  null
  
)

export default component.exports